import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setView } from '../../../redux/actions/setFilters'

import Select from '../../elements/Select'
import { viewOptions } from '../../../configuration/views'
import labels from '../../../configuration/labels'

const ViewFilter = () => {
  const currentView = useSelector(state => state.filtersData.view)
  const dispatch = useDispatch()

  const handleViewChange = e => {
    dispatch(setView(e.target.value))
  }

  return (
    <div className="flow-events__filters-view">
      <Select
        value={currentView}
        label={labels.viewAs}
        name="views"
        options={viewOptions}
        onChangeEvent={handleViewChange}
      />
    </div>
  )
}

export default ViewFilter
